"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ScaleContext_1 = require("../context/ScaleContext");
const useActiveSpectrumStyleOptions_1 = __importDefault(require("../hooks/useActiveSpectrumStyleOptions"));
const useXYReduce_1 = __importStar(require("../hooks/useXYReduce"));
const PathBuilder_1 = require("../utility/PathBuilder");
const parseColor_1 = require("../utility/parseColor");
function Line({ data, id, display, index }) {
    const { scaleX, scaleY, shiftY } = (0, ScaleContext_1.useScaleChecked)();
    const xyReduce = (0, useXYReduce_1.default)(useXYReduce_1.XYReducerDomainAxis.XAxis);
    const { opacity } = (0, useActiveSpectrumStyleOptions_1.default)(id);
    const paths = (0, react_1.useMemo)(() => {
        const _scaleX = scaleX();
        const _scaleY = scaleY(id);
        const pathBuilder = new PathBuilder_1.PathBuilder();
        if (data?.x && data?.y && _scaleX(0)) {
            const pathPoints = xyReduce(data);
            pathBuilder.moveTo(_scaleX(pathPoints.x[0]), _scaleY(pathPoints.y[0]));
            for (let i = 1; i < pathPoints.x.length; i++) {
                pathBuilder.lineTo(_scaleX(pathPoints.x[i]), _scaleY(pathPoints.y[i]));
            }
            return pathBuilder.toString();
        }
        else {
            return '';
        }
    }, [scaleX, scaleY, id, data, xyReduce]);
    const { color: stroke, opacity: strokeOpacity } = (0, parseColor_1.parseColor)(display?.color || 'black');
    return ((0, jsx_runtime_1.jsx)("path", { className: "line", "data-testid": "spectrum-line", stroke: stroke, fill: "none", strokeOpacity: opacity === 1 ? strokeOpacity : opacity, d: paths, transform: `translate(0,-${shiftY * index})` }, id));
}
exports.default = Line;
